import clsx from 'clsx';
import { PRIORITIES, PRIORITY_LABELS, type TaskPriority } from '../../../api/organizer';
import { PRIORITY_DOT_CLASSES } from '../taskUtils';

interface PriorityFieldProps {
  value: TaskPriority;
  onChange: (next: TaskPriority) => void;
  disabled?: boolean;
}

/**
 * Priority as a coloured dot plus a native select.
 *
 * A native select rather than a custom menu: four options in a dense card do not
 * justify a popover, and the native control is keyboard- and screen-reader-
 * correct for free.
 */
export function PriorityField({ value, onChange, disabled }: PriorityFieldProps) {
  return (
    <label
      className={clsx(
        'relative inline-flex cursor-pointer items-center gap-1 text-body-xs text-text-tertiary',
        disabled && 'cursor-default opacity-60',
      )}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <span className={clsx('h-2 w-2 shrink-0 rounded-full', PRIORITY_DOT_CLASSES[value])} />
      <span>{PRIORITY_LABELS[value]}</span>
      <select
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value as TaskPriority)}
        className="absolute inset-0 cursor-pointer opacity-0"
      >
        {PRIORITIES.map((priority) => (
          <option key={priority} value={priority}>
            {PRIORITY_LABELS[priority]}
          </option>
        ))}
      </select>
    </label>
  );
}
